import React, { PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';

import { trackPageVisit } from '../../utils/tracking';

import EventReviewPage from '../../components/EventReviewPage';
import {
  asyncPromises as eventDetailAsyncPromises,
  mapStateToProps as eventDetailMapStateToProps,
} from '../EventDetailPage';

/**
 * Event review page container.
 * Wraps the event review page presentational component with Redux state.
 * Reuses much of event detail page container.
 */
class EventReviewPageContainer extends PureComponent {
  componentWillMount() {
    // If the error has a status code, overwrite the route
    const { error, route } = this.props;
    if (error && error.status) {
      route.status = error.status;
    }
  }

  componentDidMount() {
    const { event, router, location } = this.props;
    // Push the event slug to the URL if it's absent
    if (event && !router.params.eventSlug) {
      router.replace(`${event.permalink}/review${location.search}${location.hash}`);
    }
    if (event) {
      trackPageVisit('Event Review');
    }
  }

  componentDidUpdate(prevProps) {
    // Event is async on client-side render if the user hasn't alerady requested the data
    if (this.props.event && !prevProps.event) {
      trackPageVisit('Event Review');
    }
  }

  render() {
    return <EventReviewPage {...this.props} />;
  }
}

EventReviewPageContainer.propTypes = EventReviewPage.propTypes;

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventReviewPageWithConnect = connect(eventDetailMapStateToProps)(EventReviewPageContainer);

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
// Configure promises that must be fulfilled before the component is rendered, e.g. fetch event data
const EventReviewPageContainerWithAsync = asyncConnect(eventDetailAsyncPromises)(EventReviewPageWithConnect); // eslint-disable-line max-len

export default EventReviewPageContainerWithAsync;



// WEBPACK FOOTER //
// ./app/src/containers/EventReviewPage/index.jsx